import request from "@/utils/request";

const session = {
    /**
     * 根据域标识和分组标识获取会话。
     * @param {Object} data
     * @param {string} data.sign 域标识
     * @param {Array}  data.groups 分组标识，多分组传入数组
     */
    getCustomerAccount(params) {
        return request({
            url: "?s=Customer.UserSession.GetCustomerAccount",
            method: "GET",
            params: params,
        });
    },

    /**
     * 获取用户的会话列表
     * @param {Object} data
     * @param {string} data.fromAccount
     */
    getSessionList(params) {
        return request({
            url: "?s=Customer.UserSession.GetSessionList",
            method: "GET",
            params: params,
        });
    },
    /**
     * 联想内容获取
     */
    getRelatedInput(params) {
        return request({
            url: "?s=Customer.common.getRelatedInput",
            method: "GET",
            params: params,
        });
    },
    /**
     * 点赞点踩
     */
    getChatEval(params) {
        return request({
            url: "?s=Customer.Common.GetChatEval",
            method: "GET",
            params: params,
        });
    },
    /**
     * 欢迎语
     */
    sendWelcome(params) {
        return request({
            url: "?s=Customer.Web.GetWelcome",
            method: "GET",
            params: params,
        });
    },
    /**
     * 文件上传
     * @param {*} data
     * @param {*} onProgress
     */
    uploadFile(data, onProgress) {
        return request({
            baseURL:
                process.env.VUE_APP_UPLOAD_API + "?s=Customer.Common.Uploads",
            method: "POST",
            data: data,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
                console.log("Log: uploadFile -> progressEvent", progressEvent);
                onProgress(progressEvent);
            },
        });
    },
};

export default session;
